import React, { useState } from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { AddButton, CancelButton, SaveButton } from '../../../../components/mui/Buttons/Buttons';
import { Form, FormikProvider, useFormik } from 'formik';
import { Box, MenuItem, Stack, TextField } from '@mui/material';
import * as Yup from 'yup';
import { CONFIG_TYPES, CONFIG_WORKING_MODE } from '../../../../utils/constants/GlobalStaticData';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { createConfig, getAllConfig } from '../../../../redux/features/configSlice';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';

const CreateConfig = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();
  const { loading, configData, alldepartments } = useSelector((state) => ({
    loading: state.config.loading,
    configData: state.config.configData,
    alldepartments: state.general.alldepartments,
  }));

  const Schema = Yup.object().shape({
    config_name: Yup.string().required('config name is required'),
  });
  const formik = useFormik({
    initialValues: {
      config_name: '',
      config_status: true,
      config_ref_id: 0,
      config_type: 1,
    },
    validationSchema: Schema,
    onSubmit: (values) => {
      dispatch(createConfig(values)).then((res) => {
        handleApiResponse(res, {
          onSuccess: () => {
            setOpen(false);
            dispatch(getAllConfig());
          },
          onFailed: () => {
            console.log('Something went wrong');
          },
        });
      });
    },
  });

  const { values, handleSubmit, handleChange, errors, touched } = formik;
  return (
    <GlobalDialog
      title={'Create config'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      fullWidth
      maxWidth={'sm'}
      popupButton={
        <AddButton size={'small'} action={() => setOpen(true)}>
          Add Config
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={handleSubmit}>
              <Box>
                <Stack direction={'column'} spacing={2}>
                 

                  <TextField
                    name="config_type"
                    label="Config Type"
                    select
                    // disabled
                    value={values.config_type}
                    onChange={handleChange}
                    error={touched.config_type && Boolean(errors.config_type)}
                    helperText={errors.config_type}
                  >
                    {CONFIG_TYPES.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>

                   <TextField
                    name="config_name"
                    label="Config Name"
                    value={values.config_name}
                    onChange={handleChange}
                    error={touched.config_name && Boolean(errors.config_name)}
                    helperText={errors.config_name}
                  />
                  
                  {values.config_type && values.config_type == 5 ? (
                    <TextField
                      name="config_ref_id"
                      label="Working Mode"
                      select
                      // disabled
                      value={values.config_ref_id}
                      onChange={handleChange}
                      error={touched.config_ref_id && Boolean(errors.config_ref_id)}
                      helperText={errors.config_ref_id}
                    >
                      {[{ id: 0, name: 'N/A' }, ...CONFIG_WORKING_MODE].map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  ) : null}

                  {values.config_type && values.config_type == 3 ? (
                    <TextField
                      name="config_ref_id"
                      label="Department"
                      select
                      // disabled
                      value={values.config_ref_id}
                      onChange={handleChange}
                      error={touched.config_ref_id && Boolean(errors.config_ref_id)}
                      helperText={errors.config_ref_id}
                    >
                      {[{ dept_id: 0, dept_name: 'N/A' }, ...alldepartments].map((item) => {
                        return (
                          <MenuItem key={item.dept_id} value={item.dept_id}>
                            {item.dept_name}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  ) : null}
                  {values.config_type && values.config_type == 6 ? (
                    <TextField
                      name="config_ref_id"
                      label={'Value'}
                      type="number"
                      onChange={handleChange}
                      value={values.config_ref_id}
                    />
                  ) : null}
                </Stack>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Stack direction={'row'} spacing={2}>
                  <CancelButton size={'small'} action={() => setOpen(false)}>
                    Cance
                  </CancelButton>
                  <SaveButton disabled={loading} size={'small'} type={'submit'}>
                    {loading ? 'Please wait...' : 'save'}
                  </SaveButton>
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default CreateConfig;
